export default {
  token_prefix: "WAREHOUSE",
  // baseURL: 'http://dicore.uz:5011/api/v1',

   baseURL: 'https://wms.gcgroup.uz:5011/api/v1',
   webSocket: 'wss://wms.gcgroup.uz:5011/notify/',

  //  baseURL: 'http://192.168.31.27:8008/api/v1',
  //  webSocket: 'http://192.168.31.27:8008/notify/',


  // baseURL: 'https://6e5a-81-95-230-194.ngrok-free.app/api/v1',
  // webSocket: '',


 // baseURL: 'http://192.168.31.111:8007/api/v1',
  //webSocket: 'ws://192.168.31.111:8007/notify/',

  
  // baseURL: 'http://192.168.31.12:8004/api/v1',
  // baseURL: 'http://192.168.31.111:8007/api/v1',
  // webSocket: 'ws://192.168.31.35:8001/notify/',



  // baseURL: 'http://dicore.uz:5011/api/v1',
  // webSocket: 'wss://dicore.uz:5011/notify/',


  // baseURL: 'https://ikhasanmusaev.jprq.live/api/v1',
  // webSocket: 'ws://ikhasanmusaev.jprq.live/notify/',
};
